import React from 'react';
import { useAuth } from '../auth/AuthContext';

const AccessDeniedPage: React.FC = () => {
    const { user, signOutAdmin } = useAuth();
    return (
        <div className="login-shell">
            <div className="card shadow-lg" style={{ width: '100%', maxWidth: 480 }}>
                <div className="card-body p-4 text-center">
                    <i className="bi bi-shield-exclamation text-danger" style={{ fontSize: '3rem' }} />
                    <h4 className="mt-3 mb-2">Accesso negato</h4>
                    <p className="text-body-secondary">
                        L'account <code>{user?.email ?? '—'}</code> è autenticato ma
                        non ha il ruolo <strong>Admin</strong> in Semplora.
                    </p>
                    <p className="small text-body-secondary">
                        Se ritieni che sia un errore, contatta un altro amministratore.
                    </p>
                    <button onClick={signOutAdmin} className="btn btn-outline-danger mt-2">
                        <i className="bi bi-box-arrow-right me-2" />
                        Esci
                    </button>
                </div>
            </div>
        </div>
    );
};

export default AccessDeniedPage;
